import { PropTypes } from 'prop-types';
import React from 'react';

import CardTextBasedSmallScrolling from '../Cards/CardTextBased/CardTextBasedSmallScrolling';

const HomepageHeroLatest = ({ content, isMobile }) => {
  return (
    <div data-module-id="homepage_hero_latest">
      <div className={`${isMobile ? 'global-padding-container' : ''}`}>
        <h4 className="lg:mb-2 mb-4 sm:mb-6 pb-3.5 border-b stink-h4 border-smoke">
          Latest
        </h4>
      </div>
      <div
        className={`${
          isMobile ? 'global-padding-container' : ''
        } grid grid-flow-col overflow-auto lg:flex lg:flex-col no-scrollbar gap-x-6 lg:gap-x-0`}
      >
        {content.map((item) => {
          const { id, slug, title } = item;
          return (
            <div
              className="w-56 lg:w-auto"
              data-component-id="homepage_hero_latest_link"
            >
              <CardTextBasedSmallScrolling key={id} slug={slug} title={title} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

HomepageHeroLatest.propTypes = {
  content: PropTypes.array,
  isMobile: PropTypes.bool,
};

export default HomepageHeroLatest;
